import { render, staticRenderFns } from "./import-products.modal.vue?vue&type=template&id=7a876d80&scoped=true"
import script from "./import-products.modal.vue?vue&type=script&lang=js"
export * from "./import-products.modal.vue?vue&type=script&lang=js"
import style0 from "./import-products.modal.vue?vue&type=style&index=0&id=7a876d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a876d80",
  null
  
)

export default component.exports